<div class="mobile-corte-container" *ngIf="corteDetalles">
  <header class="mobile-corte-header">
    <div class="corte-meta">
      <h2>Corte</h2>
      <span class="corte-id">#{{ corteDetalles.id }}</span>
    </div>
    <button mat-icon-button color="primary" (click)="onCancel()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="corte-section info">
    <div class="info-block">
      <label>Fecha de Creación</label>
      <span>{{ formatearFecha(corteDetalles.createdAt) }}</span>
    </div>
    <div class="info-block">
      <label>Proveedor</label>
      <span>{{ corteDetalles.proveedor?.nombre || 'N/A' }}</span>
    </div>
    <div class="info-block">
      <label>Estado</label>
      <mat-chip [color]="getEstadoColor(corteDetalles.estado)" selected>{{ corteDetalles.estado | titlecase }}</mat-chip>
    </div>
    <div class="info-block">
      <label>Fecha Inicio</label>
      <span>{{ formatearFecha(corteDetalles.fechaInicio) }}</span>
    </div>
    <div class="info-block">
      <label>Fecha Fin</label>
      <span>{{ formatearFecha(corteDetalles.fechaFin) }}</span>
    </div>
  </section>

  <section class="corte-section resumen">
    <h3>Resumen Financiero</h3>
    <div class="resumen-row">
      <span>Monto Total</span>
      <strong>{{ formatearMoneda(corteDetalles.montoTotal) }}</strong>
    </div>
    <div class="resumen-row">
      <span>Monto Pagado</span>
      <strong class="success">{{ formatearMoneda(corteDetalles.montoPagado) }}</strong>
    </div>
    <div class="resumen-row total">
      <span>Saldo Pendiente</span>
      <strong [class.warning]="calcularSaldoPendiente() > 0">
        {{ formatearMoneda(calcularSaldoPendiente()) }}
      </strong>
    </div>
  </section>

  <section class="corte-section detalles">
    <h3>Detalles del Corte</h3>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let detalle of corteDetalles.detalles">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ detalle.detalleVenta?.producto?.nombre || 'N/A' }}
          </mat-panel-title>
          <mat-panel-description>
            {{ formatearMoneda(detalle.monto) }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="detalle-grid">
          <div>
            <label>Producto</label>
            <span>{{ detalle.detalleVenta?.producto?.nombre || 'N/A' }}</span>
          </div>
          <div>
            <label>Código</label>
            <span>{{ detalle.detalleVenta?.producto?.codigo || 'N/A' }}</span>
          </div>
          <div>
            <label>Venta ID</label>
            <span>{{ detalle.detalleVenta?.venta?.id || 'N/A' }}</span>
          </div>
          <div>
            <label>Fecha Venta</label>
            <span>{{ detalle.detalleVenta?.venta?.fecha ? formatearFecha(detalle.detalleVenta.venta.fecha) : 'N/A' }}</span>
          </div>
          <div>
            <label>Vendedor</label>
            <span>{{ detalle.detalleVenta?.venta?.usuario?.name || 'N/A' }}</span>
          </div>
          <div>
            <label>Cantidad</label>
            <span>{{ detalle.detalleVenta?.cantidad || 0 }}</span>
          </div>
          <div>
            <label>P. Unitario</label>
            <span>{{ formatearMoneda(detalle.detalleVenta?.precioUnitario || 0) }}</span>
          </div>
          <div>
            <label>Monto</label>
            <strong>{{ formatearMoneda(detalle.monto) }}</strong>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </section>

  <section class="corte-section observaciones" *ngIf="corteDetalles.observaciones">
    <h3>Observaciones</h3>
    <p>{{ corteDetalles.observaciones }}</p>
  </section>

  <div class="mobile-corte-actions">
    <button mat-raised-button color="primary" (click)="onCancel()" class="full-width">
      Cerrar
    </button>
  </div>
</div>

<div class="loading-container" *ngIf="isLoading">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Cargando detalles del corte...</p>
</div>

